import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';

const documents = {
    methods : {
        handleSlide: (el)=>{
            const downloadFormsEl = $(el).find('.documents-cmp__download--section');
            const accordionLabel = downloadFormsEl.prev('button');
            downloadFormsEl.addClass('hidden-el');
            $(accordionLabel).on(CONSTANT.eventsListners.CLICK,function(){
                if(downloadFormsEl.hasClass('hidden-el')){
                    downloadFormsEl.slideDown();
                    downloadFormsEl.removeClass('hidden-el');
                    accordionLabel.addClass('opened');
                }
                else{
                    downloadFormsEl.slideUp();
                    downloadFormsEl.addClass('hidden-el');
                    accordionLabel.removeClass('opened');
                }
            });
        },

         accordionClickHandler: function () {
             $('.documents-cmp__container').on('click', '.documents-cmp__download--button', function () {
                 let container = $(this).closest('.documents-cmp__wrapper');
                 let titleElement = container.find('.documents-cmp__info-contents--title h3');
                 let title = null;
                 if (titleElement.length > 0) {
                     title = titleElement.text().trim();
                 }
                 if ($(this).hasClass('opened')) {
                     var obj = documents.methods.dataLayerObj($(this), title);
                     createDataLayer('Expand', obj);
                 }
             });
         },

            dataLayerObj: function (el,e) {
              var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': el ? el.text().replace(/\n/g, '').trim() : "",
                'pageSection': e ? e : "Document Component",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption': "",
                'productCategory': "",
                'productName': "",
                'question': "",
                'source': "",
                'searchTerm': "",
                'videoTitle': "",
                'bannerName': "",
              };
              return obj;
            },

        init : ()=>{
            $('.documents-cmp__wrapper').each((idx,ele)=>{
                documents.methods.handleSlide(ele);
            });
        }
    }
};


$(()=>{
    if($('.documents-cmp__wrapper').length){
        documents.methods.init();
    }
});
$(document).ready(function () {
  documents.methods.accordionClickHandler();
});
